import { createFileRoute } from "@tanstack/react-router";
import PreturiParticulari from "@/pages/PreturiParticulari";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/preturi-particulari/")({
  head: () => routeHead("/preturi-particulari/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <PreturiParticulari />
  );
}
